import React from "react";

function ButtonPrimary({ children, className, onClick }) {
  return (
    <button onClick={onClick} className={`${"btnPrimary"} ${className}`}>
      {children}
    </button>
  );
}

export default ButtonPrimary;
